var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHospital1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.494,
    height: 13.195,
    viewBox: "0 0 16.494 13.195",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hospital",
    d: "M4.948,1.237A1.237,1.237,0,0,1,6.185,0h4.123a1.237,1.237,0,0,1,1.237,1.237V13.2H9.484V11.133a1.237,1.237,0,0,0-2.474,0V13.2H4.948ZM1.237,2.474H4.123V13.2H1.237A1.237,1.237,0,0,1,0,11.958V8.247H2.062a.412.412,0,1,0,0-.825H0V5.773H2.062a.412.412,0,1,0,0-.825H0V3.711A1.237,1.237,0,0,1,1.237,2.474Zm14.02,0a1.237,1.237,0,0,1,1.237,1.237V4.948H14.432a.412.412,0,0,0,0,.825h2.062V7.422H14.432a.412.412,0,0,0,0,.825h2.062v3.711A1.237,1.237,0,0,1,15.257,13.2H12.37V2.474ZM8.041,1.649a.414.414,0,0,0-.412.412V2.68H7.01a.414.414,0,0,0-.412.412V3.5a.414.414,0,0,0,.412.412h.619v.619a.414.414,0,0,0,.412.412h.412a.414.414,0,0,0,.412-.412V3.917h.619A.414.414,0,0,0,9.9,3.5V3.093a.414.414,0,0,0-.412-.412H8.865V2.062a.414.414,0,0,0-.412-.412Z",
    fill: "#047BC1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHospital1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hospital-1.2e3751139e36031036a6112b95ec8e5f.svg";